exports = module.exports = require("../../../../../node_modules/.0.28.9@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-container[data-v-71a57ac8]{font-size:0;text-align:center}img[data-v-71a57ac8]{max-width:100%;max-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.28.9@css-loader?minimize!./node_modules/.13.7.1@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71a57ac8","scoped":true,"hasInlineConfig":false}!./node_modules/.13.7.1@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/components/messageBox/components/ImagePreviewBox.vue
// module id = 72
// module chunks = 0 1